import HeaderPopup from "@components/header/components/popover/HeaderPopup"
import { container } from "@components/wrapper"
import { Tab } from "@headlessui/react"
import { useRisebinar, useSchools } from "@hooks/data"
import { useCourseCategory } from "@lib/hooks/data/useCourse"
import clsx from "clsx"
import { useEffect, useState } from "react"
import { LinkHead } from "../HeaderComponent"

interface TabMenu {
  title: string
  description: string
}

interface PanelMenu extends TabMenu {
  links: LinkItem[]
}

interface LinkItem {
  label: string
  url: string
}

const PROGRAM_MENU = [
  {
    title: "Bootcamp",
    description: "Belajar intensif dengan career coaching dan job-guarantee, hanya dalam 3-6 bulan",
  },
  {
    title: "Proclass",
    description:
      "Kuasai skill profesional dengan tepat dan dapat kerja cepat, hanya dalam 1 -2 bulan",
  },
  {
    title: "Video Course",
    description: "Belajar bersama tutor profesional dan kurikulum industri di mana pun, kapan pun",
  },
  {
    title: "Event & Workshop",
    description: "Upgrade skill dan kejar karier impian dengan event & workshop berkualitas",
  },
]

export const ServiceDropdown = ({ setIsHover }: any) => {
  const [tabMenus, setTabMenus] = useState<TabMenu[]>([])
  const [panelMenus, setPanelMenus] = useState<PanelMenu[]>([])

  const { data: bootcamps } = useSchools("BOOTCAMP")
  const { data: proClasses } = useSchools("PRO_CLASS")
  const { data: risebinars } = useRisebinar()
  const { data: categories } = useCourseCategory()

  useEffect(() => {
    const makeMenu = async () => {
      try {
        const tabMenu: TabMenu[] = []
        const panelMenu: PanelMenu[] = []

        for (let i = 0; i < PROGRAM_MENU.length; i++) {
          const element = PROGRAM_MENU[i]

          switch (true) {
            case i === 0 && Boolean(bootcamps.length):
              {
                tabMenu.push(element)
                const menus: LinkItem[] = bootcamps.map((item) => {
                  return {
                    label: item.product_name,
                    url: `/school/bootcamp/${item.product_slug}`,
                  }
                })
                panelMenu.push({
                  ...element,
                  links: menus,
                })
              }

              break
            case i === 1 && Boolean(proClasses.length):
              {
                tabMenu.push(element)
                const menus: LinkItem[] = proClasses.map((item) => {
                  return {
                    label: item.product_name,
                    url: `/school/proclass/${item.product_slug}`,
                  }
                })
                panelMenu.push({
                  ...element,
                  links: menus,
                })
              }

              break
            case i === 2 && Boolean(categories.length):
              {
                tabMenu.push(element)
                const menus: LinkItem[] = categories.map((item) => {
                  return {
                    label: item.category_name,
                    url: `/learning/category/${item.category_slug}`,
                  }
                })
                panelMenu.push({
                  ...element,
                  links: menus,
                })
              }

              break
            case i === 3 && Boolean(risebinars.length):
              {
                tabMenu.push(element)
                const menus: LinkItem[] = risebinars.map((item) => {
                  return {
                    label: item.risebinar_title,
                    url: `/risebinar/${item.risebinar_slug}`,
                  }
                })
                panelMenu.push({
                  ...element,
                  links: menus,
                })
              }

              break

            default:
              break
          }
        }

        setTabMenus(tabMenu)
        setPanelMenus(panelMenu)
      } catch (error) {
        if (process.env.NODE_ENV !== "production") {
          console.log(error)
        }
      }
    }

    makeMenu()
  }, [bootcamps, proClasses, risebinars, categories])

  const PopoverComponent = () => {
    return (
      <Tab.Group>
        <div className={clsx(container)}>
          <Tab.List className="flex gap-8 text-md font-medium relative ">
            {tabMenus.map((item, idx) => (
              <Tab
                className={({ selected }) =>
                  clsx(
                    selected &&
                      "text-green after:contents-[''] after:w-full after:h-[2px] after:absolute after:bg-green after:-bottom-2 after:left-0",
                    `cursor-pointer relative`
                  )
                }
                key={idx}
              >
                {item.title}
              </Tab>
            ))}
          </Tab.List>

          <Tab.Panels>
            {panelMenus.map((item, idx) => (
              <Tab.Panel key={idx}>
                <div className="mt-4 text-2xl font-medium">{item.title}</div>

                <div className="flex gap-12 mt-4 ">
                  <div className="w-2/5">{item.description}</div>
                  <div className="grid grid-cols-2 gap-2 w-1/2">
                    {item.links.map((link, index) => (
                      <LinkHead key={index} link={link.url}>
                        {link.label}
                      </LinkHead>
                    ))}
                  </div>
                </div>
              </Tab.Panel>
            ))}
          </Tab.Panels>
        </div>
      </Tab.Group>
    )
  }

  return <HeaderPopup setIsHover={setIsHover} panel={<PopoverComponent />} buttonLabel="Program" />
}
